import React, { useState, useEffect } from 'react';
import {  FaEye, FaDownload , FaFilePdf} from 'react-icons/fa';
import { PadaRecordProps, LocalizedData, Nonces } from './types';
import './styles.css';


// Declaración para datos globales en la ventana
declare global {
  interface Window {
    PadaVistaData?: LocalizedData;
  }
}


const downloadFile = (fileUrl: string, fileName: string) => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

export const PadaRecord: React.FC<PadaRecordProps> = ({ site_url, record }) => {
  const typeOrder = ['PAT002', 'PAT001'];
  
  // Agrupar archivos por type_id
  const groupedFiles: { [key: string]: typeof record.transparency_files } = {};
  record.transparency_files
    ?.filter(file => file.is_active === "1")
    .forEach(file => {
      if (typeof file.type_id === 'string') {
        if (!groupedFiles[file.type_id]) {
          groupedFiles[file.type_id] = [];
        }
        groupedFiles[file.type_id].push(file);
      }
    });

  return (
    <div className="frac-list">
      <div className="pada-list-grid">
        <div key={record.record_id} className="frac-card pada-card">            
          <div className="frac-card-body pada-card-body">
            <h3 className="frac-name pada-description">{record.record_description}</h3>
              {/* Lista de archivos de transparencia */}
              {record.transparency_files && record.transparency_files.length > 0
                ? (
                  <div className="transparency-files">
                    <div key={'down-' + record.record_id} className='files-list'>
                      {typeOrder.filter(typeId => groupedFiles[typeId]).length > 0
                        ? (
                          typeOrder
                            .filter(typeId => groupedFiles[typeId])
                            .map(typeId => (
                              <div key={typeId}>
                                <h4 className="file-type">{groupedFiles[typeId][0].type_name || 'Archivo'}</h4>
                                {groupedFiles[typeId].map((file, index) => (
                                  <div key={file.transparency_file_id || index} className="file-item">
                                    <span className="file-icon"><FaFilePdf /></span>
                                    <div className="file-info">
                                      <span className="file-name" title={file.file_name}>{file.file_name}</span>
                                    </div>
                                    <div className="file-actions">
                                      <button
                                        className="modify-btn"
                                        onClick={() => window.open(site_url + '/wp-content/uploads/' + file.file_path, '_blank')}
                                        title="Ver archivo"
                                      >
                                        <FaEye />
                                      </button>
                                      <button
                                        className="modify-btn"
                                        onClick={() => downloadFile(site_url + '/wp-content/uploads/' + file.file_path, file.file_name)}
                                        title="Descargar archivo"
                                        style={{ backgroundColor: '#6366f1', color: 'white' }}
                                      >
                                        <FaDownload />
                                      </button>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ))
                        )
                        : (
                          <div className="no-transparency-files">
                            <p>No hay archivos de transparencia disponibles para este registro.</p>
                          </div>
                        )
                      }
                    </div>
                  </div>
                )
                : (
                  <div className="no-transparency-files">
                    <p>No hay archivos disponibles.</p>
                  </div>
                )
              }
          </div>
        </div>
      </div>
    </div>
  )
};


export default PadaRecord;
